import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeatureCards() {
  const articleList = articles.slice(0, 9);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-[1280px] mx-auto">
          {/* Header */}
          <div className="flex flex-col items-center text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400">
              Pandabuy / SBS
            </span>
            <h2 className="mt-4 font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 tracking-tight">
              SEO Guides &amp; Articles
            </h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg">
              In-depth <strong>pandabuyspreadsheet</strong> guides to level up your sourcing game
            </p>
          </div>

          {/* 9 Article Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articleList.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-200 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-md">
                      {article.category}
                    </span>
                    <span className="text-foreground-400 text-xs">{article.readTime} read</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-accent-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                  <p className="mt-4 text-accent-500 text-sm font-medium flex items-center gap-1.5 group-hover:gap-2 transition-all duration-200">
                    Read Article
                    <i className="ri-arrow-right-line text-base"></i>
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* View all link */}
          <div className="mt-10 text-center">
            <Link
              to="/pandabuy-sheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 text-sm font-medium rounded-full hover:border-foreground-400 hover:bg-background-100 transition-all duration-200"
            >
              View All Guides
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}